import {InfoModule} from '@fantasmagames/slot/src/modules/hud/info/InfoModule';
import {GameInfoModuleBasicState} from 'src/info/states/GameInfoModuleBasicState';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';
import {GameInfoModuleFreeSpinsState} from 'src/info/states/GameInfoModuleFreeSpinsState';
import {GameWinPresentationEvents} from 'src/winpresentation/GameWinPresentationEvents';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {RecodeInfoModule} from '@fantasmagames/slot/src/modules/hud/info/recode/RecodeInfoModule';

export class GameInfoModule extends RecodeInfoModule {

	protected setupStates(): void {
		super.setupStates();

		this.addState(new GameInfoModuleBasicState(this, InfoModule.BASIC));
		this.addState(new GameInfoModuleFreeSpinsState(this, InfoModule.FREESPINS));
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.onCurrentStateHandle(AvalancheReelsEvents.REMOVING_WIN_FINISHED);
		this.onCurrentStateHandle(GameWinPresentationEvents.AFTER_MULTIPLIER_COUNTING_FINISHED);
		this.onCurrentStateHandle(WinPresentationEvents.WIN_NUMBER_SHOWN_TO_PLAYER);
	}
}



// WEBPACK FOOTER //
// ./src/info/GameInfoModule.ts